import { render, staticRenderFns } from "./failureTable.vue?vue&type=template&id=4b439ea0"
import script from "./failureTable.vue?vue&type=script&lang=js"
export * from "./failureTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports